const locale = {
  TITLE: "User Page",
};

export default locale;
